import { TallyMark4Icon } from './TallyMark4Icon';

/**
 * author: Michael Irigoyen
 * id 85D71807-B7C3-48C8-8E8D-951AA54B68C7
 * name tally-mark-4
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tally-mark-4.svg
 * tags
 * - Math 
 */
export const FourIcon = TallyMark4Icon;
export default FourIcon